import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import React from 'react';

export const FormContext = React.createContext<WrappedFormUtils | null>(null);

const CreditsRow = ({ form, index, ...props }: {form: WrappedFormUtils, index: number}) => (
    <FormContext.Provider value={form}>
        <tr {...props} />
    </FormContext.Provider>
);

export default Form.create()(CreditsRow);
